import { render, staticRenderFns } from "./UserTwoFactorTable.vue?vue&type=template&id=714e9fc8&scoped=true&"
import script from "./UserTwoFactorTable.vue?vue&type=script&lang=js&"
export * from "./UserTwoFactorTable.vue?vue&type=script&lang=js&"
import style0 from "./UserTwoFactorTable.vue?vue&type=style&index=0&id=714e9fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714e9fc8",
  null
  
)

export default component.exports